import { Modal } from 'flowbite';
import type { ModalOptions, ModalInterface } from 'flowbite';
import axios from 'axios';
import JustValidate from 'just-validate';
// import { Rules } from "just-validate/dist/modules/interfaces";

declare let core_object: any;
declare let localize_object: any;

export default class forgotPassword{ 

    elBtnForgotPassword: string;
    elModalForgotPassword: string;
    btnCloseForgotPasswordModal: string;
    protected url_api_modal: string;

    constructor(
        elBtnForgotPassword: string,
        elModalForgotPassword: string,
        btnCloseForgotPasswordModal: string
    ){
        
        this.elBtnForgotPassword = elBtnForgotPassword;
        this.elModalForgotPassword = elModalForgotPassword;
        this.btnCloseForgotPasswordModal = btnCloseForgotPasswordModal;

        this.url_api_modal = core_object.rest_urls.comments_forgot_password_modal;

    }

    /**
     * Get template
     */
    getTemplateModal(){
        
        const _that = this;
        const el = document.getElementById(this.elBtnForgotPassword);

        el?.addEventListener("click", function(e){
            e.preventDefault();

            const containModal = document.getElementById(_that.elModalForgotPassword);

            if(containModal == null){
                
                const post_data = {
                    ajax_nonce: core_object.ajaxNonce,
                };
        
                const queryString = new URLSearchParams(post_data).toString();
                
                // Call ajax
                axios.post(_that.url_api_modal, queryString)
                    .then(function (response: any) {
                    
                    // Get status
                    const responseStatus: boolean = response.data.status;

                    if(responseStatus == true){

                        const getModal = response.data.template;

                        // Append modal
                        document.body?.insertAdjacentHTML('beforeend', getModal);

                        // Show form
                        _that.showForm(el);

                    }

                    if(responseStatus == false){
                        
                        

                    }

                })
                .catch(function (error:any){

                    

                });
    
            }else{
                
                _that.showForm(el);

            }
 
        });

    }

    /**
     * Get modal
     * @returns 
     */
    protected initModal(){

        const targetEl = document.getElementById(this.elModalForgotPassword) as HTMLElement | null;

        const modalOptions: ModalOptions = {
            placement: 'top-center',
            backdrop: 'static',
            backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-[60]'
        }

        const modal: ModalInterface = new Modal(targetEl, modalOptions);

        modal.hide();

        return modal;

    }

    /**
     * Show form
     * @param el 
     */
    protected showForm(el: HTMLElement){
        
        const _that = this;

        const modal = _that.initModal();

        // Set disabled attribute
        el?.setAttribute('disabled', '');

        // Show modal
        modal.show();

        // Validate form
        // const validation = _that.validateLogin();
        
        // Close modal
        const elClose = document.getElementById(_that.btnCloseForgotPasswordModal);

        elClose?.addEventListener("click", function(e){
            e.preventDefault();
            
            // Destroy validation
            // validation.destroy();

            // Remove disabled attribute
            el?.removeAttribute('disabled');

            // Modal Hide
            modal.hide();

        });

    }

}